import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { setPostLoginUri } from './utilities';
import { AccessDenied } from '../pages';
import { logger } from '../logging';

export const RequireAuth = () => {
  const auth = useAuth();

  React.useEffect(() => {
    setPostLoginUri();
  }, []);

  React.useEffect(() => {
    if (
      !auth.isAuthenticated &&
      window.location.pathname !== '/signin-callback'
    ) {
      void auth.actions.login().catch((e: any) => {
        logger.error('RequireAuth: login redirect failed', {
          error: { message: e.message, stack: e.stack },
        });
      });
    }
  }, [auth]);

  if (!auth.isAuthenticated) {
    return null;
  }

  if (!auth.isValidUserType) {
    return <AccessDenied />;
  }

  return <Outlet />;
};
